export const actionTypes = {
  INCREMENT_CONNECT_CURRENT_DOMAIN_STEP:
    "INCREMENT_CONNECT_CURRENT_DOMAIN_STEP",
  DECREMENT_CONNECT_CURRENT_DOMAIN_STEP:
    "DECREMENT_CONNECT_CURRENT_DOMAIN_STEP",
  SET_CONNECT_CURRENT_DOMAIN_STEP: "SET_CONNECT_CURRENT_DOMAIN_STEP",
  HELP_INSTRUCTIONS_VISIBLE: "HELP_INSTRUCTIONS_VISIBLE",
  HELP_INSTRUCTIONS_HIDDEN: "HELP_INSTRUCTIONS_HIDDEN",
  SET_SELECTED_DNS_PROVIDERS: "SET_SELECTED_DNS_PROVIDERS",
  SET_DOMAIN_NAME: "SET_DOMAIN_NAME",
};

export const actions = {
  incrementDomainStep: () => ({
    type: actionTypes.INCREMENT_CONNECT_CURRENT_DOMAIN_STEP,
  }),
  decrementDomainStep: () => ({
    type: actionTypes.DECREMENT_CONNECT_CURRENT_DOMAIN_STEP,
  }),
  setConnectCurrentDomainStep: (payload: number) => ({
    type: actionTypes.SET_CONNECT_CURRENT_DOMAIN_STEP,
    payload,
  }),
  showHelpInstructions: () => ({
    type: actionTypes.HELP_INSTRUCTIONS_VISIBLE,
  }),
  hideHelpInstructions: () => ({
    type: actionTypes.HELP_INSTRUCTIONS_HIDDEN,
  }),
  setSelectedDNSProviders: (payload: string) => ({
    type: actionTypes.SET_SELECTED_DNS_PROVIDERS,
    payload,
  }),
  setDomainName: (payload: string) => ({
    type: actionTypes.SET_DOMAIN_NAME,
    payload,
  }),
};
